import { origin_point_engine_api } from '@/lib/axios-client'

// 无可奈何，本应该通过 orval 统一生成的 hook 来写，但后端的端点没能生成这个swagger 端点

/** 审核操作（通过/拒绝） */
export async function postReviewEngine(input: {
  engineId: string
  action: 'approve' | 'reject'
  note: string
}) {
  return origin_point_engine_api({
    url: `/admin/engines/${input.engineId}/review`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: {
      action: input.action,
      note: input.note,
    },
  })
}
